import rgba from "./rgba";

/**
 * Builds a single box-shadow css value.
 * offset: [x, y], radius: [blur, spread]
 */
function boxShadow(offset = [], radius = [], color, opacity, inset = "") {
  const [x, y] = offset;
  const [blur, spread] = radius;

  return `${inset} ${pxOrZero(x)} ${pxOrZero(y)} ${pxOrZero(blur)} ${pxOrZero(
    spread
  )} ${rgba(color, opacity)}`.trim();
}

function pxOrZero(value) {
  return `${value || 0}px`;
}

export default boxShadow;
